<template>
  <div @click.right="clickActionPreventDefault" @click.middle="clickActionPreventDefault"
    @touchstart="touchActionPreventDefault" @copy="clickActionPreventDefault" @dblclick="clickActionPreventDefault">
    <Toast />
    <AppTopBar v-if="!isMobile()" />
    <div class="pb-0" :class="{ 'layout-main-container': !isMobile() }"
      v-show="!appStore.isRouteHidden(route)">
      <RouterView v-if="appStore.screenNumber" />
      <SelectScreenNumber v-if="!appStore.screenNumber" @selected="onScreenNumberSelect" />
    </div>
  </div>
</template>

<script setup>
import { onMounted, watch } from 'vue';
import { useAppStore } from '@/stores/app';
import { useRoute, RouterView } from "vue-router";
import AppTopBar from './AppTopBar.vue'
import SelectScreenNumber from './components/SelectScreenNumber.vue'
import { isMobile, loadScreenNumber, clickActionPreventDefault, touchActionPreventDefault } from './services/screen';
import { enterFullscreen, isFullscreen } from './services/fullscreen';
import { preferences, applyPreferences } from './services/preferences';

const route = useRoute();
const appStore = useAppStore();

watch(() => route.path, () => handleMobileDevice());
onMounted(() => {
  appStore.screenNumber = loadScreenNumber();
  applyPreferences();
  restoreFullscreenPreference();
});

// Browsers block auto-entering fullscreen on load, so if the booth previously
// chose fullscreen we re-enter it on the operator's first interaction.
const restoreFullscreenPreference = () => {
  if (isMobile() || !preferences.fullscreenPreferred || isFullscreen()) return;
  document.addEventListener('pointerdown', () => {
    // Re-check the preference at gesture time: the operator may have pressed Esc
    // (which clears fullscreenPreferred) before this first interaction fired.
    if (preferences.fullscreenPreferred && !isFullscreen()) enterFullscreen();
  }, { once: true });
};

const handleMobileDevice = () => {
  if (isMobile()) setDefaultScreenNumber();
}

const setDefaultScreenNumber = () => {
  appStore.screenNumber = loadScreenNumber(-1);
}

const onScreenNumberSelect = (screenNumber) => {
  appStore.screenNumber = loadScreenNumber(screenNumber);
};
</script>

<style scoped></style>
